import React, { useEffect } from "react";

import { UserIdIcon } from "@common/components/DetailsPane/icons";
import { Spinner } from "@common/components/Spinner/Spinner";
import displayToast from "@common/components/Toast/displayToast";
import useAuthorizeApiConsumer from "@main/pages/Authorize/consumers/AuthorizeApiConsumer";
import { ShakeIcon } from "@main/pages/shared/icons/icons";
import { RoutePaths } from "@main/router/config/routePaths";
import { generatePath, useNavigate, useSearchParams } from "react-router-dom";

import * as Styled from "./AuthorizeElement.styles";

export default function AuthorizeElement() {
  const navigate = useNavigate();

  const [params] = useSearchParams();
  const [name, setName] = React.useState<string>("");
  const [description, setDescription] = React.useState<string>("");

  // Validate required parameters
  const requiredParams = [
    "client_id",
    "redirect_uri",
    "code_challenge",
    // "code_challenge_method",
    // Optional i guess
    // "state",
    // "scope",
    // "resource",
  ];

  useEffect(() => {
    const missingParams = requiredParams.filter((param) => !params.get(param));

    if (missingParams.length > 0) {
      displayToast({
        title: "Invalid Request",
        content: `Missing required parameters: ${missingParams.join(", ")}`,
      });
      navigate(generatePath(RoutePaths.ROOT));
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, navigate]);

  const { getInfo, authorize, isLoading } = useAuthorizeApiConsumer({
    client_id: params.get("client_id") || undefined,
    redirect_uri: params.get("redirect_uri") || undefined,
    state: params.get("state") || undefined,
    scope: params.get("scope") || undefined,
    code_challenge: params.get("code_challenge") || undefined,
    code_challenge_method: params.get("code_challenge_method") || undefined,
    resource: params.get("resource") || undefined,
  });

  useEffect(() => {
    const loadInfo = async () => {
      const result = await getInfo();
      if (result) {
        setName(result.data.name || "");
        setDescription(result.data.description || "");
      }
    };
    loadInfo();
  }, [getInfo]);

  const handleCancel = () => {
    // TODO: Delete grant before returning
    navigate(generatePath(RoutePaths.ROOT));
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Styled.Container>
      <Styled.Header as={"h1"}>
        <ShakeIcon
          height={40}
          width={40}
        />
        Shakebugs
      </Styled.Header>
      <Styled.IconContainer>
        <UserIdIcon
          height={60}
          width={60}
        />
        <ShakeIcon
          height={60}
          width={60}
        />
      </Styled.IconContainer>
      <Styled.Title as={"h3"}>{name} is requesting access to access Shakebugs</Styled.Title>
      <Styled.Subtitle>
        <a href={description}>{name}</a> will be able to
      </Styled.Subtitle>
      <Styled.Permission>
        <Styled.Subtitle>See and access issues</Styled.Subtitle>
        <Styled.Subtitle>Access logs</Styled.Subtitle>
      </Styled.Permission>
      {/* TODO: Add more scopes here */}
      {/* TODO: Add option to revoke access */}
      <Styled.Footer>
        <Styled.Button onClick={authorize}>Authorize</Styled.Button>
        <Styled.CancelButton
          onClick={handleCancel}
          color="grey"
        >
          Cancel
        </Styled.CancelButton>
      </Styled.Footer>
    </Styled.Container>
  );
}
